import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { FilterCallbackUnique } from '../../../../../../utility/ArrayUtility';
import { hitObjectiveIdsSelector } from '../../../slices/ObjectivesSlice';

const useObjectiveGroupFractionComplete = (objectiveGroup) => {
  const hitObjectiveIds = useSelector(hitObjectiveIdsSelector);

  const objectivesWithPoints = useMemo(() => {
    return objectiveGroup.objectives.filter((objective) => {
      return (
        objective.scoreMetadata?.points && objective.scoreMetadata.points > 0
      );
    });
  }, [objectiveGroup]);

  const fractionComplete = useMemo(() => {
    const groupObjectiveIds = objectivesWithPoints.map((obj) => obj.id);
    const groupObjectiveIdsHit = hitObjectiveIds
      .filter(FilterCallbackUnique)
      .filter((id) => groupObjectiveIds.includes(id));
    return groupObjectiveIdsHit.length / objectivesWithPoints.length;
  }, [hitObjectiveIds, objectivesWithPoints]);

  return fractionComplete;
};

export default useObjectiveGroupFractionComplete;
